module.exports = __webpack_public_path__ + "img/2022-08.6f1b334d.jpg";